import React from 'react';
import {Form, Textarea, List} from 'components';
import {useNamedSelector} from 'helpers';

export function Wealth() {
  return (
    <Form {...useNamedSelector('clarity.form', { name: 'wealth' })}>
      <List tiny-gutter>
        <List.Title>What would make you feel financially secure?</List.Title>
        <Textarea single name="1" />
        <List.Title>What are your greatest concerns about money?</List.Title>
        <Textarea single name="2" />
        <List.Title>What does wealth symbolize to you?</List.Title>
        <Textarea single name="3" />
        <List.Title>How would financial security enhance your life?</List.Title>
        <Textarea single name="4" />
        <List.Title>When do worries about money stop you from doing what you want?</List.Title>
        <Textarea single name="5" />
        <List.Title>What would you do with a million dollars?</List.Title>
        <Textarea single name="6" />
        <List.Title>What could you do to take control of your finances?</List.Title>
        <Textarea single name="7" />
        <List.Title>When do you make irresponsible/responsible financial decisions?</List.Title>
        <Textarea single name="8" />
      </List>
    </Form>
  );
}
